import { NgModule } from '@angular/core';
import { MessagesService } from './messages.service';
import { LoadingModule } from 'ngx-loading';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MessagesComponent } from './messages.component';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { MatSelectModule } from '@angular/material';
import { DeleteConfirmDialogComponent } from '../../shared/components/delete-confirm-dialog/delete-confirm-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LoadingModule,
    InfiniteScrollModule,
    MatSelectModule,
    SharedModule
  ],
  entryComponents: [
    DeleteConfirmDialogComponent
  ],
  providers: [MessagesService],
  declarations: [
    MessagesComponent
  ]
})
export class MessagesModule { }



// WEBPACK FOOTER //
// ./src/app/entities/messages/messages.module.ts